<template>
  <div class="loging in" v-if="$store.getters.getIsPortalAllowed">
      <b-card
          border-variant="secondary"
          header-bg-variant="secondary"
          header-text-variant="white"
          :header="getTitle"
          align="center"
          style="max-width: 40rem;"
          class="mx-auto"
      >
        <b-container>
        <b-row align-h="end" class="mb-0 mt-0" >
            <b-button v-b-toggle.authToken_info class="shadow-none"  aria-hidden="true" variant="white"
                    v-b-tooltip.hover.topright :title="$t('loginOut.credsHeader')" >  <b-icon icon="info-circle"></b-icon></b-button>
        </b-row>
        </b-container>
        <b-button @click="login" class="m-2" variant="outline-primary" v-b-tooltip.hover.topright :title="$t('loginOut.loginToolTip')"> {{ $t('loginOut.loginButton') }}</b-button>

        <b-card-body>
          <b-collapse id="authToken_info"  accordion="my-accordion" >
              <b-row class="my-1 border-bottom border-light">{{ $t('loginOut.tokenInfo')}}</b-row>
              <b-row class="my-1 border-bottom border-light">
                <b-col sm="4" class="font-weight-bold"> {{ $t('loginOut.secret') }}</b-col>
                <b-col sm="8"> {{$store.getters.getTenantAuthToken}}</b-col>
              </b-row>
          </b-collapse>
        </b-card-body>

      </b-card>
  </div>
  <div v-else>
    <h2>You are not authorized to access this site, please contact your property manager for assistance.</h2>
  </div>
</template>

<script>

import store from "@/store/store";
import axios from "axios";

export default {
  name: 'logingIn',
  async mounted () {
    await axios.get(location.origin.toString() + "/residents/properties/" +
        store.getters.getPropertyGuid + "/access").then(
        result => {
          store.commit('SET_ACCESS_INFORMATION', result.data)
        }, error => {
          console.error(error);
        });
    await  store.getters.getIsPortalAllowed;
  },
  created () {
    store.dispatch('Logout');
  },
  computed: {
    getTitle() {
      if (store.getters.getLoginText !== "") {
        return store.getters.getLoginText
      } else {
        return this.$t('loginOut.welcome')
      }
    }
  },
  methods:{
    login(){
      store.dispatch("AuthenticateToApi")
    }
  }
}
</script>
